
/* Components =================================================================================== */
import { AppLayoutClass } from '../../../components/app-layout'

/* App Layout Init ============================================================================== */
const AppLayout = new AppLayoutClass({ id: 'public-users' })

AppLayout.setConfig({
  header: {
    active: false,
  },
  navbar: {
    active: false,
  },
  toolbar: {
    active: false,
  },
  menubar: {
    active: false,
  },
})

export default AppLayout
